import styled from "styled-components";

export const StyledSpan = styled.span`
  ${({ theme }) => `
      font-size: ${theme.font.size.sm};
      margin-right: ${theme.space.sm};
  `}
`;
